import AdtInfoTitleListPanel from "./adtInfoTitleListPanel.container";

export default AdtInfoTitleListPanel;
